var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clients-actions"},[_c('div',{staticClass:"spacer"}),_c('div',{staticClass:"search"},[_c('tol-type-ahead',{attrs:{"search-params":{
        url: ("/clients/" + _vm.clientReference),
        searchKeys: ['searchParam'],
        urlParams: {
          sortBy: '',
          sortDirection: '',
          clientsFilterPreference: '',
          clientsTypeFilterPreference: '',
          contactsRecordsPerPage: _vm.getClientDetailsContactsRecordsPerpage,
          contactsRecordsOffset: _vm.getClientDetailsContactsRecordsOffset
        }
      },"results-in-dropdown":false},on:{"filtered":function($event){return _vm.onFiltered($event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }